/**
 * Brazilian phone numbers on the API are stored as E.164: `55` (country code) +
 * 10 or 11 local digits, no formatting. The dashboard form shows the masked
 * value `(DD) XXXXX-XXXX`. These helpers convert between the two.
 */

const BR_COUNTRY_CODE = '55';

/**
 * Convert a masked or loosely formatted BR phone to E.164.
 * Returns `""` for empty input so callers can decide whether to omit the field.
 */
export const toE164BR = (input: string): string => {
  const digits = input.replace(/\D/g, '');
  if (digits.length === 0) return '';
  if (digits.startsWith(BR_COUNTRY_CODE) && (digits.length === 12 || digits.length === 13)) {
    return digits;
  }
  return `${BR_COUNTRY_CODE}${digits}`;
};

/**
 * Convert E.164 BR phone to masked `(DD) XXXXX-XXXX` for display.
 * Returns `""` for empty input.
 */
export const fromE164BR = (e164: string): string => {
  if (!e164) return '';
  const digits = e164.replace(/\D/g, '');
  const local = digits.startsWith(BR_COUNTRY_CODE) ? digits.slice(BR_COUNTRY_CODE.length) : digits;
  if (local.length === 11) return `(${local.slice(0, 2)}) ${local.slice(2, 7)}-${local.slice(7)}`;
  if (local.length === 10) return `(${local.slice(0, 2)}) ${local.slice(2, 6)}-${local.slice(6)}`;
  return local;
};
